import React from "react";

function NoCommentView() {
  return (
    <div className="pending-timeoff-no-comment-wrapper" style={{ marginLeft: "9px" }}>
      No comment available
    </div>
  );
}

export default NoCommentView;
